import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardActiveRequestsUpdate } from '../../../store/requestsState/effects/boardActiveRequestsUpdate';
import { webhooksPostRest } from './api/helpers/webhooksPostRest';

export const webhooksSave = (
    boardId: TBoardId,
    webhooks: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(boardActiveRequestsUpdate(boardId, 1));
        return dispatch(webhooksPostRest(boardId, webhooks))
            .then((webhooks: string) => {
                return webhooks;
            })
            .finally(() => {
                dispatch(boardActiveRequestsUpdate(boardId, -1));
            });
    };
    return action;
}
